import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

// Suppress global "Network Error" alerts
const originalAlert = window.alert;
window.alert = function (message) {
  if (message && (message.toString().toLowerCase().includes("network error") || message.toString().toLowerCase().includes("something went wrong"))) {
    console.warn("Suppressed network error alert:", message);
    return;
  }
  originalAlert.apply(this, arguments);
};

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <React.Fragment>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <App />
    </BrowserRouter>
  </React.Fragment>
);